import { render, staticRenderFns } from "./LearningOutcome.vue?vue&type=template&id=34f8814a"
import script from "./LearningOutcome.vue?vue&type=script&lang=js"
export * from "./LearningOutcome.vue?vue&type=script&lang=js"
import style0 from "./LearningOutcome.vue?vue&type=style&index=0&id=34f8814a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports